import { PrintToPdfWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('PrintToPdf')
export class PrintToPdfConnectorProvider extends ConnectorProvider<PrintToPdfWorkflowNode> {}
